/**
 * 会員登録ポップアップ
 *
 * 未ログインユーザーに対して会員登録を促すポップアップを表示する。
 * 表示トリガー:
 *   1. ページを50%以上スクロールしたとき
 *   2. マウスがブラウザ上端から離脱したとき（exit-intent、3秒後に有効化）
 *   3. レビューリンク（URLに /reviews/ を含むリンク）をクリックしたとき（遷移を一時保留してポップアップ表示）
 *
 * 1ページ内で複数回トリガーが発生しても、ポップアップは1回しか表示しない。
 * 「しばらく表示しない」チェックを入れて閉じると、24時間はlocalStorageで非表示にする。
 */
document.addEventListener('DOMContentLoaded', function () {
  const popup = document.getElementById('registration-popup');
  if (!popup) return;

  const overlay = document.getElementById('overlay');
  const closeBtn = popup.querySelector('.registration-popup-close');
  const hideCheck = popup.querySelector('#hide-registration-popup');

  let pendingLink = null; // レビューリンク押下時に遷移先を一時保持
  let popupShown = false;

  const HIDE_DURATION = 24 * 60 * 60 * 1000; // 24時間
  popup.dataset.modal = 'closed';

  // 「しばらく表示しない」が有効期間内かどうか
  function isHiddenRecently() {
    const hideTime = localStorage.getItem('hideRegistrationPopup');
    if (!hideTime) return false;
    const diff = Date.now() - Number(hideTime);
    return diff < HIDE_DURATION;
  }

  function showPopup() {
    if (popupShown) return;
    if (isHiddenRecently()) return;
    popup.dataset.modal = 'opened';
    overlay.style.display = 'block';
    popupShown = true;
  }

  function hidePopup() {
    popup.dataset.modal = 'closed';
    overlay.style.display = 'none';
    // チェックが入っていれば非表示期間を記録
    if (hideCheck && hideCheck.checked) {
      localStorage.setItem('hideRegistrationPopup', Date.now());
    }
    // レビューリンク経由で表示された場合、閉じた後に元のリンク先へ遷移
    if (pendingLink) {
      window.location.href = pendingLink;
      pendingLink = null;
    }
  }

  closeBtn.addEventListener('click', hidePopup);
  overlay.addEventListener('click', hidePopup);

  // トリガー1: 画面サイズのスクロール50%で表示
  window.addEventListener('scroll', function () {
    if (popupShown) return;
    if (window.scrollY > window.innerHeight * 0.5) {
      showPopup();
    }
  });

  // トリガー2: exit-intent（マウスが上端から離脱）
  // 即座に発火しないよう3秒の猶予を設ける
  let allowExitIntent = false;
  setTimeout(function () {
    allowExitIntent = true;
  }, 3000);

  document.addEventListener('mouseleave', function (e) {
    if (!allowExitIntent) return;
    if (popupShown) return;
    if (e.clientY <= 0) {
      showPopup();
    }
  });

  // トリガー3: レビューリンク（URLに /reviews/ を含む）のクリックを横取りしてポップアップ表示
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a');
    if (!link) return;
    if (link.pathname && /\/reviews\//.test(link.pathname)) {
      if (isHiddenRecently()) return;
      if (popupShown) return;
      e.preventDefault();
      pendingLink = link.href;
      showPopup();
    }
  });
});
